<template>
    <div class="input-file-button">
        <button @click="$refs.input.click()"><img width="30" src="@/assets/images/components/select_image.svg"/></button>
        <input ref="input" type="file" class="hidden" :value="value" :accept="accept" @change="e => $emit('change', e)">
    </div>
</template>

<script lang='ts'>
    import { Vue } from 'vue-property-decorator'
    import { PropType } from 'vue'

    export default Vue.extend({
        props: {
            value: Object,
            accept: String,
        },
        components: {

        },
        data() {
            return {
                
            }
        },
        computed: {

        },
        methods: {

        },
    })

    </script>

<style lang="scss" scoped>
    .input-file-button{
        input {
            display: none;
            position: absolute;
        }
    }
</style>
